<section class="pt-0 pb-0" id="iq-businessned">
    <div class="container">
        <div class="row">
            <div class="col-lg-6">
                <app-v-two-section-title [titleSectionProp]="titleSectionProp"></app-v-two-section-title>


                <div class="text-left">
                    <ul class="iq-list mb-5">
                        <li *ngFor="let service of List">
                            <i [ngClass]="service.icon"></i>
                            <span>{{ service.title }}</span>
                        </li>
                    </ul>
                    <!-- <a class="button blue-btn gradient-btn button-icon" href="#"><span class="btn-effect"> Empezar ahora</span></a> -->
                </div>
            </div>
            <div class="col-lg-6">
                <img src="./assets/sofbox-v2/images/home-8/907.png" alt="fancybox">
            </div>
        </div>
    </div>
</section>